import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useUserID } from "Flocknote/stateHooks";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";

const useFontColor = () => {
  const { isDark } = useMemberToobarContext();

  return useMemo(() => {
    if (isDark) return "textLight";
    return "textPrimary";
  }, [isDark]);
};

const usePathToProfile = () => {
  const userID = useUserID();

  return useMemo(() => `/user/${userID}`, [userID]);
};

const useIsOnProfilePage = () => {
  const location = useLocation();
  const pathToProfile = usePathToProfile();
  return useMemo(
    () => location?.pathname === pathToProfile,
    [location?.pathname, pathToProfile]
  );
};

export { useFontColor, usePathToProfile, useIsOnProfilePage };
